// extracted by mini-css-extract-plugin
export var acitonButtons = "_fm-0";
export var additionalIcon = "_fm-f";
export var block = "_fm-1";
export var blockContent = "_fm-7";
export var blockDescription = "_fm-8";
export var blockIcon = "_fm-9";
export var blockTitle = "_fm-6";
export var border = "_fm-a";
export var center = "_fm-l";
export var edge = "_fm-b";
export var edgeLabel = "_fm-c";
export var edgePath = "_fm-d";
export var error = "_fm-e";
export var flowchart = "_fm-g";
export var flowchartContent = "_fm-h";
export var highlighted = "_fm-3";
export var hover = "_fm-4";
export var icon = "_fm-i";
export var left = "_fm-m";
export var navButton = "_fm-j";
export var navButtons = "_fm-k";
export var right = "_fm-n";
export var selected = "_fm-2";
export var small = "_fm-5";